import createIcon from '../../createIcon';

/**
 * @component @name Interests
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNNy4wMiAxMy41QzQuODEgMTMuNSAzLjAyIDE1LjI5IDMuMDIgMTcuNUMzLjAyIDE5LjcxIDQuODEgMjEuNSA3LjAyIDIxLjVDOS4yMyAyMS41IDExLjAyIDE5LjcxIDExLjAyIDE3LjVDMTEuMDIgMTUuMjkgOS4yMyAxMy41IDcuMDIgMTMuNVpNMTMgMTMuNVYyMS41SDIxVjEzLjVIMTNaTTcgMi41TDIgMTEuNUgxMkw3IDIuNVpNMTkuMjUgM0MxOC4xOSAzIDE3LjQ0IDMuNTYgMTcgNC4xN0MxNi41NiAzLjU2IDE1LjgxIDMgMTQuNzUgM0MxMy4xOSAzIDEyIDQuMjggMTIgNS43NUMxMiA3Ljc1IDE0LjQyIDkuMTcgMTcgMTEuNUMxOS41OCA5LjE3IDIyIDcuNzUgMjIgNS43NUMyMiA0LjI4IDIwLjgxIDMgMTkuMjUgM1oiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Interests = createIcon('Interests', [
  [
    'path',
    {
      d: 'M7.02 13.5C4.81 13.5 3.02 15.29 3.02 17.5C3.02 19.71 4.81 21.5 7.02 21.5C9.23 21.5 11.02 19.71 11.02 17.5C11.02 15.29 9.23 13.5 7.02 13.5ZM13 13.5V21.5H21V13.5H13ZM7 2.5L2 11.5H12L7 2.5ZM19.25 3C18.19 3 17.44 3.56 17 4.17C16.56 3.56 15.81 3 14.75 3C13.19 3 12 4.28 12 5.75C12 7.75 14.42 9.17 17 11.5C19.58 9.17 22 7.75 22 5.75C22 4.28 20.81 3 19.25 3Z',
      key: '4p4tru',
    },
  ],
]);

export default Interests;
